export const LESS_THAN_ZERO = 'LESS_THAN_ZERO'
export const LESS_THAN_THIRTY = 'LESS_THAN_THIRTY'
export const ARRIVAL_DEPARTURE_OVERLAP_TIME = 0
export const ARRIVAL_DEPARTURE_THRESHOLD = 30
